module.exports = __webpack_public_path__ + "static/media/lakshmi-vilas-bank.5dcb8224.png";